import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Episode } from './Model';

export function EpisodeListItem(props: { item: Episode }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%'  }}>
            <CardContent sx={{ flex: 'auto' }}>
                <Typography component="div" variant="h5">
                    {props.item.title}
                </Typography>
                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{ color: 'text.secondary' }}
                >
                    {props.item.subtitle}
                </Typography>
            </CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
            </Box>
        </Box>
    );
}
